// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"ed0bacc9","93":"7be603d9","525":"b6015edf","774":"e1785866"}[chunkId] + ".chunk.js";
};